import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiLinkDTO,
  LinkDTO,
} from "@lib/strapi/dtos/components/shared/link.dto";
import { getImageProps, ImageProps } from "@lib/image";

export class LinkService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiLinkDTO,
  ): Promise<LinkDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new LinkDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.title = strapiData.title;
    dto.url = strapiData.url;
    dto.target = strapiData.target;
    dto.file = getImageProps(strapiData.file);
    dto.className = strapiData.className;
    return dto;
  }
}
